export interface InactiveFD {
  bot_name?: string;
  bot_client_name?: string;
  last_interaction?: string;
  days_inactive: number | string;
  organization_name?: string;
  organization_email?: string;
  organization_owner_email?: string;
}

export interface InactiveRangeConfig {
  id: string;
  label: string;
  min: number;
  max: number;
}

export interface InactiveRangeGroup {
  range: InactiveRangeConfig;
  items: InactiveFD[];
}

export const INACTIVE_RANGES: InactiveRangeConfig[] = [
  { id: '1-5', label: '1-5 dias', min: 1, max: 5 },
  { id: '6-10', label: '6-10 dias', min: 6, max: 10 },
  { id: '11-15', label: '11-15 dias', min: 11, max: 15 },
  { id: '16-20', label: '16-20 dias', min: 16, max: 20 },
  { id: '21-25', label: '21-25 dias', min: 21, max: 25 },
  { id: '26-30', label: '26-30 dias', min: 26, max: 30 },
  { id: '31-35', label: '31-35 dias', min: 31, max: 35 },
  { id: '36-40', label: '36-40 dias', min: 36, max: 40 },
  { id: '41-45', label: '41-45 dias', min: 41, max: 45 }
];

export function resolveInactiveRangeConfig(value: number | string): InactiveRangeConfig | undefined {
  const days = Number.parseInt(String(value), 10);

  if (!Number.isFinite(days)) {
    return undefined;
  }

  return INACTIVE_RANGES.find(range => days >= range.min && days <= range.max);
}

export function groupInactiveFDsByRange(fds: InactiveFD[]): InactiveRangeGroup[] {
  const groups = INACTIVE_RANGES.map(range => ({ range, items: [] as InactiveFD[] }));

  fds.forEach(fd => {
    const range = resolveInactiveRangeConfig(fd.days_inactive);
    if (!range) {
      return;
    }

    const bucket = groups.find(group => group.range.id === range.id);
    if (bucket) {
      bucket.items.push(fd);
    }
  });

  return groups.filter(group => group.items.length > 0);
}

export function buildInactiveCsv(fds: InactiveFD[]): string {
  const header = 'Nome,Última interação,Dias inativos,Faixa,Organização,Email';
  const rows = fds.map(fd => {
    const name = fd.bot_name || fd.bot_client_name || '';
    const lastInteraction = fd.last_interaction || '';
    const daysInactive = fd.days_inactive ?? '';
    const range = resolveInactiveRangeConfig(daysInactive);
    const rangeLabel = range ? range.label : '45+ dias';
    const organization = fd.organization_name || '';
    const email = fd.organization_email || '';

    const values = [name, lastInteraction, daysInactive, rangeLabel, organization, email];
    return values
      .map(value => `${value ?? ''}`.replace(/"/g, '""'))
      .map(value => `"${value}"`)
      .join(',');
  });

  return [header].concat(rows).join('\n');
}
